import placeholderImage from '../images/placeholder.webp';
import { Link } from 'react-router-dom';

const MerchCard = ({ merch, speaker, onRemove }) => {
    return (
        <div className="merch-card">
            {onRemove ? (
                <button className="merch-remove" onClick={() => onRemove(merch.id)}>
                    {'\u00D7'}
                </button>
            ) : null}
            <img src={merch.images?.length ? process.env.REACT_APP_MEDIA_URL + merch.images[0] : placeholderImage} alt={merch.name} />
            <div className="merch-info">
                <div className="merch-name">{merch.name}</div>
            </div>
            <div className="merch-price">
                ${merch.price.toFixed(2)}
            </div>
            {!!speaker && (<div className="">
                <Link to={'/merch'} state={{id: merch.id, speaker}} className="btn">Edit</Link>
            </div>)}
        </div>
    );
}

export default MerchCard;